import { useState, useEffect } from 'react';

/**
 * Custom hook to load House System data from CMS API
 * Returns parsed house system data including houses, title, description, etc.
 */
export function useHouseSystem() {
  const [houseSystemData, setHouseSystemData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadHouseSystemData = async () => {
      setIsLoading(true);
      try {
        // Get API base - for production use full URL, for dev use localhost
        const apiBase = process.env.REACT_APP_API_BASE 
          ? process.env.REACT_APP_API_BASE 
          : 'https://permataharapansecondary.sch.id/api';
        
        // Fetch CMS sections (public endpoint, no auth required)
        const response = await fetch(
          `${apiBase}/studentlife/cms/sections?published=true&_t=${Date.now()}`,
          {
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              'Pragma': 'no-cache'
            }
          }
        );

        if (!response.ok) {
          throw new Error(`API returned ${response.status}`);
        }

        const result = await response.json();

        if (result.ok && Array.isArray(result.data)) {
          // Find house system section
          const houseSystemSection = result.data.find(
            s => s.section_type === 'student-life-house-system'
          );

          if (houseSystemSection) {
            // Parse content_published
            let published = houseSystemSection.content_published;
            if (typeof published === 'string') {
              published = JSON.parse(published);
            }

            const enData = published?.en || {};
            setHouseSystemData(enData);
            setError(null);
          } else {
            throw new Error('House System section not found in CMS');
          }
        } else {
          throw new Error('Invalid API response format');
        }
      } catch (err) {
        console.error('[useHouseSystem] Error loading house system data:', err);
        setError(err.message);
        setHouseSystemData(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadHouseSystemData();
  }, []);

  return {
    houseSystemData,
    isLoading,
    error
  };
}
